import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children, siteData }) => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow">
                {children}
            </main>
            <Footer siteData={siteData} />
        </div>
    );
};

export default Layout;